// @flow
/** @jsx h */
import { h, VNode } from 'preact';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useImperativeHandle, useRef } from 'preact/hooks';
import { forwardRef } from 'preact/compat';

type Props = {
  children: VNode,
  setting?: Object,
};
// Slick slider doesn't work well with goober styles, use module css.
const SlickSlider = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    nextSlide() {
      slider.current.slickNext();
    },
    prevSlide() {
      slider.current.slickPrev();
    },
  }));
  const slider = useRef(null);
  const slideSetting = {
    lazyLoad: 'ondemand',
    dots: true,
    arrows: false,
    swipeToSlide: false,
    slidesToShow: 1,
    infinite: true,
    autoplaySpeed: 10000,
    touchThreshold: 100,
    ...props.setting,
  };
  return (
    <Slider ref={slider} {...slideSetting}>
      {props.children}
    </Slider>
  );
});

export default SlickSlider;



// WEBPACK FOOTER //
// ./componentsBICRevamp/common/slickSlider/index.js